import React, { useMemo } from "react";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";

import StageSelectBox from "@app/component/input/StageSelectBox";
import { DealFieldName } from "@app/util/fieldModel/DealFieldModel";
import { getQuickFilterDetailsForField } from "@app/util/filters/utils";

export const STAGE_FILTER_OPERATORS = [FilterOperator.IN_ANY, FilterOperator.NONE_OF];

const doesSupportValue = (value: any, operator: FilterOperator) =>
  Array.isArray(value) &&
  value.every((item) => typeof item === "number") &&
  STAGE_FILTER_OPERATORS.includes(operator);

interface StageFilterProps extends IFilterComponentProps {}

const StageFilter: IFilterInstance = {
  doesSupportValue,
  getComponent:
    (): React.FunctionComponent<StageFilterProps> =>
    ({ className, disabled, filterModel, onChange, options, placeholder, value }) => {
      const selectedFunnelsIds = useMemo(() => {
        const [funnelCondition, valid] = getQuickFilterDetailsForField(
          filterModel,
          DealFieldName.FUNNEL,
          (condition) =>
            (condition.operator === FilterOperator.EQUALS && typeof condition.value === "number") ||
            ([FilterOperator.IN_ANY, FilterOperator.NONE_OF].includes(condition.operator) &&
              Array.isArray(condition.value))
        );
        if (!funnelCondition || !valid) {
          return (options?.availableFunnels as Funnel[])?.map(({ id }) => id) ?? [];
        }

        return funnelCondition.operator === FilterOperator.EQUALS
          ? [funnelCondition.value]
          : funnelCondition.value;
      }, [filterModel, options?.availableFunnels]);

      return (
        <StageSelectBox
          className={className}
          disabled={disabled}
          onChange={(stagesIds: Stage["id"][]) => onChange?.({ ...value, value: stagesIds })}
          placeholder={placeholder}
          selectedFunnelsIds={selectedFunnelsIds}
          value={value.value}
        />
      );
    },
};

export default StageFilter;
